import { useInfiniteQuery } from '@tanstack/vue-query'
import type { MaybeRef } from '@vueuse/core'
import type { MaybeRefOrGetter } from '@tanstack/vue-query/build/legacy/types'
import { TanStackQueryIds } from '../query-ids'
import { type ElementalQuery, getElementals } from '~~/src/api/elementals'
const Query = { page: 1, size: 10 }

export const useElementalsInfiniteQuery = (
  args: {
    query?: MaybeRef<ElementalQuery | undefined>
  },
  options?: {
    enable?: MaybeRefOrGetter<boolean>
  },
) => {
  return useInfiniteQuery({
    initialPageParam: args.query || Query,
    queryKey: ([TanStackQueryIds.ELEMENTALS_INFINITY, args.query] as const),
    queryFn: async ({ signal, queryKey, pageParam }) => {
      const [_, query] = queryKey
      return getElementals({ ...query, ...pageParam }, signal)
    },
    getNextPageParam(lastPage, allPages) {
      const query = unref(args.query) || Query
      if (!lastPage || lastPage.length === 0 || lastPage.length < (query.size || Query.size))
        return undefined

      return {
        page: allPages.length + 1,
        size: query.size || Query.size,
      }
    },
    getPreviousPageParam(firstPage, allPages) {
      const query = unref(args.query) || Query

      if (!firstPage || firstPage.length === 0 || firstPage.length < (query?.size || Query.size))
        return undefined

      return {
        page: allPages.length - 1,
        size: query?.size || Query.size,
      }
    },
    ...options,
  })
}
